/**
 * Утилита для улучшенной обработки таблиц из DOCX
 */

/**
 * Анализирует и улучшает HTML таблицы после конвертации из DOCX
 * @param {string} html - HTML строка с таблицами
 * @returns {string} - Обработанный HTML
 */
export function processDocxTables(html) {
  // Создаем временный DOM элемент для парсинга HTML
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  
  // Обрабатываем каждую таблицу
  const tables = tempDiv.querySelectorAll('table');
  
  tables.forEach(table => {
    // Устанавливаем базовые стили для таблицы
    table.style.borderCollapse = 'collapse';
    table.style.width = '100%';
    table.style.margin = '10px 0';
    table.setAttribute('border', '1');
    
    // Анализируем структуру таблицы
    const rows = table.querySelectorAll('tr');
    if (rows.length === 0) return;
    
    // Определяем количество колонок
    const firstRowCells = rows[0].querySelectorAll('td, th');
    const numCols = firstRowCells.length;
    
    // Проходим по всем ячейкам таблицы
    rows.forEach((row, rowIndex) => {
      const cells = row.querySelectorAll('td, th');
      
      cells.forEach((cell, cellIndex) => {
        // Базовые стили для ячейки
        cell.style.border = '1px solid #ccc';
        cell.style.padding = '8px';
        
        // Для заголовков таблицы
        if (cell.tagName === 'TH') {
          cell.style.backgroundColor = '#f5f5f5';
          cell.style.fontWeight = 'bold';
          // Заголовки обычно центрируются
          if (!cell.style.textAlign) {
            cell.style.textAlign = 'center';
          }
        }
        
        // Анализируем содержимое ячейки для определения выравнивания
        const content = cell.textContent.trim();
        const originalContent = cell.innerHTML;
        
        // Проверяем параграфы внутри ячейки
        const paragraphs = cell.querySelectorAll('p');
        if (paragraphs.length === 1) {
          const p = paragraphs[0];
          
          // Проверяем стили параграфа
          if (p.style.textAlign) {
            cell.style.textAlign = p.style.textAlign;
          } else if (p.className) {
            // Проверяем классы
            if (p.className.includes('text-center') || p.className.includes('cell-center')) {
              cell.style.textAlign = 'center';
            } else if (p.className.includes('text-right') || p.className.includes('cell-right')) {
              cell.style.textAlign = 'right';
            } else if (p.className.includes('text-justify')) {
              cell.style.textAlign = 'justify';
            }
          }
          
          // Удаляем обертку параграфа если он единственный
          cell.innerHTML = p.innerHTML;
        }
        
        // Эвристика для определения выравнивания по типу содержимого
        if (!cell.style.textAlign) {
          // Числа обычно выравниваются по правому краю
          if (/^\d+([.,]\d+)?$/.test(content)) {
            cell.style.textAlign = 'right';
          }
          // Даты тоже часто по правому краю
          else if (/^\d{1,2}[./-]\d{1,2}[./-]\d{2,4}$/.test(content)) {
            cell.style.textAlign = 'right';
          }
          // Короткий текст в верхней строке часто центрируется (заголовки)
          else if (rowIndex === 0 && content.length < 20) {
            cell.style.textAlign = 'center';
          }
          // Проверяем наличие ведущих/завершающих пробелов в оригинальном HTML
          else if (originalContent.startsWith('  ') || originalContent.startsWith('&nbsp;&nbsp;')) {
            // Множественные пробелы в начале могут указывать на центрирование
            if (originalContent.endsWith('  ') || originalContent.endsWith('&nbsp;&nbsp;')) {
              cell.style.textAlign = 'center';
            }
          }
        }
        
        // Устанавливаем ширину колонок равномерно если не указано иное
        if (!cell.style.width && numCols > 0) {
          cell.style.width = Math.floor(100 / numCols) + '%';
        }
      });
    });
    
    // Проверяем наличие colgroup и обрабатываем его
    const colgroup = table.querySelector('colgroup');
    if (colgroup) {
      const cols = colgroup.querySelectorAll('col');
      cols.forEach((col, index) => {
        if (col.getAttribute('width')) {
          // Применяем ширину к соответствующим ячейкам
          rows.forEach(row => {
            const cells = row.querySelectorAll('td, th');
            if (cells[index]) {
              cells[index].style.width = col.getAttribute('width');
            }
          });
        }
      });
    }
  });
  
  return tempDiv.innerHTML;
}

/**
 * Определяет выравнивание текста на основе визуального анализа
 * @param {string} text - Текст для анализа
 * @returns {string|null} - Тип выравнивания или null
 */
export function detectTextAlignment(text) {
  // Удаляем HTML теги для чистого анализа
  const cleanText = text.replace(/<[^>]*>/g, '');
  
  // Проверяем паттерны выравнивания
  if (/^\s{4,}.*\s{4,}$/.test(cleanText)) {
    return 'center';
  }
  if (/^\s{4,}/.test(cleanText) && !/\s{4,}$/.test(cleanText)) {
    return 'right';
  }
  if (!/^\s{4,}/.test(cleanText) && /\s{4,}$/.test(cleanText)) {
    return 'left';
  }
  
  return null;
}